import { useRef } from "react";
import { FormikProps } from "formik";
import { useParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Container, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useLoginLinkRequestMutation, useUser, useUserUpdateMutation } from "src/hooks/users";
import { UserForm, UserFormData } from "src/forms/UserForm";
import { PageHeader } from "src/components/page/PageHeader";

interface Props {
  onClose: (originAction?: "delete") => void;
}

export function UserEditPage(props: Props) {
  const {userId = ""} = useParams<{
    userId: string;
  }>();
  const { t } = useTranslation();
  const { data: user } = useUser(userId);
  const loginLinkRequestMutation = useLoginLinkRequestMutation();

  // dirty data is the local only (unsaved) version of server data
  // TODO: this will be used in v2.0 when editing is possible
  // const [dirtyData, setDirtyData] = useState<Partial<ScenarioMutationData>>();
  const formRef = useRef<FormikProps<UserFormData> | null>(null);

  const updateMutation = useUserUpdateMutation(userId);

  /**
   * Effects
   */
  // ...

  /**
   * Functions
   */

  async function handleSave(values: UserFormData) {
    if (!user) return Promise.reject();
    await updateMutation.mutateAsync(values);
    props.onClose();
  }

  function handleLoginLinkRequest() {
    if (!user) return;
    loginLinkRequestMutation.mutate(user.authUserId);
  }

  return render();

  function render() {
    if (!user) return null;

    return (
      <StyledContainer maxWidth="lg">
        <Paper>
          <PageHeader>
            <Typography variant="h3" noWrap className="page-title">
              {t("label.editUser")}
            </Typography>
          </PageHeader>

          <UserForm
            key={userId}
            data={user}
            isLoading={updateMutation.isLoading}
            onSubmit={handleSave}
            onClose={() => {
              props.onClose();
            }}
            onLoginLinkRequest={handleLoginLinkRequest}
            errors={updateMutation.error?.response?.data}
            formRef={formRef}
          />
        </Paper>
      </StyledContainer>
    );
  }
}

const StyledContainer = styled(Container)`
  .MuiPaper-root {
    padding: ${({ theme }) => theme.spacing(3)};
  }
`;
